import { ref, reactive, onUnmounted } from 'vue'


export function useVideoController(videoYtRef: any, vimeoPlayerRef: any) {

  const openNote = reactive({ status: false })
  const openVideo = reactive({ status: false })
  const openHistory = reactive({ status: false })
  const openCC = ref(false)


  let outsideHandler: ((e: MouseEvent) => void) | null = null

  function setupClickOutside(selector: string, close: () => void) {
    const element = document.querySelector(selector) as HTMLElement
    if (!element) return

    outsideHandler = (event: MouseEvent) => {
      if (!element.contains(event.target as Node)) {
        close()
        document.removeEventListener('mouseup', outsideHandler!)
      }
    }

    document.addEventListener('mouseup', outsideHandler)
  }

  function toggleVmodal() {
    openVideo.status = !openVideo.status
    if (openVideo.status) {
      openNote.status = false
      openHistory.status = false
      setupClickOutside('.videoModal', () => (openVideo.status = false))
    }
  }

  function toggleNbook() {
    openNote.status = !openNote.status
    if (openNote.status) {
      openVideo.status = false
      openHistory.status = false
      setupClickOutside('.noteBook', () => (openNote.status = false))
    }
  }

  function toggleHistory() {
    openHistory.status = !openHistory.status
    if (openHistory.status) {
      openNote.status = false
      openVideo.status = false
      setupClickOutside('.hisModal', () => (openHistory.status = false))
    }
  }

  function toggleCC() {
    openCC.value = !openCC.value
  }



  onUnmounted(() => {
    if (outsideHandler) document.removeEventListener('mouseup', outsideHandler)
  })

  return {
    openNote,
    openVideo,
    openHistory,
    openCC,
    toggleVmodal,
    toggleNbook,
    toggleHistory,
    toggleCC
  }
}